/**
 * Matematik 4, chapter 1 — where its sections start and stop.
 *
 * This file used to hold the whole chapter typed out by hand: 143 exercises, their prompts, the
 * full facit and the formula boxes. That transcription is gone, and the sentence that removed it
 * is the owner's: **nobody reads a typed version of a page they own.** The page itself is the
 * book now — `BookPane` renders the PDF, a click on an exercise clips it onto the sheet, and the
 * parser survives only to find those click regions and to locate the facit.
 *
 * What is left is not a transcription. It is a table of contents: which numbers belong to which
 * section, and where the chapter begins and ends. An ingested book derives exactly the same
 * shape from its own pages (`ingestedView` in `lib/books.ts`), so this is the seed for the one
 * chapter that existed before ingest did — what the board groups by, what the log filters by,
 * and the range a fresh workspace is created with.
 */

export interface BookSection {
  number: string;
  title: string;
  from: number;
  to: number;
}

export const CHAPTER = {
  number: '1',
  title: 'Trigonometri',
  from: 1001,
  to: 1143,
};

export const SECTIONS: BookSection[] = [
  { number: '1.1.1', title: 'Repetition av trigonometri', from: 1001, to: 1007 },
  { number: '1.1.2', title: 'Enhetscirkeln och trigonometriska ekvationer', from: 1008, to: 1020 },
  { number: '1.1.3', title: 'Radianer', from: 1021, to: 1027 },
  { number: '1.1.4', title: 'Symmetrier i enhetscirkeln', from: 1028, to: 1035 },
  { number: '1.1.5', title: 'Trigonometriska ettan', from: 1036, to: 1047 },
  { number: '1.1.6', title: 'Additions- och subtraktionsformler', from: 1048, to: 1060 },
  { number: '1.1.7', title: 'Trigonometriska ekvationer med formler', from: 1061, to: 1070 },
  { number: '1.1.8', title: 'Problemlösning med trigonometriska identiteter', from: 1071, to: 1083 },
  { number: '1.2.1', title: 'Funktionerna y = sin x och y = cos x', from: 1084, to: 1088 },
  { number: '1.2.2', title: 'Amplitud, period och förskjutning', from: 1089, to: 1102 },
  { number: '1.2.3', title: 'Tangensfunktionen', from: 1103, to: 1108 },
  { number: '1.2.4', title: 'Modellering med trigonometriska funktioner', from: 1109, to: 1115 },
  { number: '1.3', title: 'Blandade övningar', from: 1116, to: 1143 },
];

export const sectionAt = (n: number): BookSection | undefined =>
  SECTIONS.find(s => n >= s.from && n <= s.to);
